import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { ButtonGroup, Dropdown, DropdownButton } from 'react-bootstrap';
import { CallAPI } from 'actions/General';
import FormButton from 'components/form-components/FormButton';
import dotsIcon from 'assets/images/icons/table-icons.svg';
import dropdownIcon from 'assets/images/icons/dropdown-arrow-white.svg';
import ConfirmationModal from 'components/common-components/ConfirmationModal';
import toast from 'react-hot-toast';

function UsersActions({ ids, isActionButton, type, actionsCallBack, row }) {
  const [displayedMenu, setDisplayedMenu] = useState([]);
  const [confirmationModal, setConfirmationModal] = useState(false);
  const [actionType, setActionType] = useState('');
  const [loader, setLoader] = useState(false);
  const { t } = useTranslation();

  const applyUserAction = async () => {
    if (actionType === 'unBlock') {
      await CallAPI(
        'UNBLOCK_USER',
        { isOtpBlocked: row.otpManager?.otpStatus === 'blocked' },
        ids[0],
        setLoader,
        null,
        null,
      );
      setConfirmationModal(false);
      actionsCallBack();
    } else if (actionType === 'delete') {
      const resp = await CallAPI(
        'DELETE_USER_PERMANENTLY',
        { companyId: row.company._id, companyUserId: row._id },
        null,
        setLoader,
        null,
        null,
      );
      if (resp.status) toast.success('User deleted successfully');
      else toast.error('Failed to delete user');

      setConfirmationModal(false);
      actionsCallBack();
    }
  };
  const handleAction = (type) => {
    setActionType(type);
    setConfirmationModal(true);
  };

  useEffect(() => {
    let UsersActionsList = [
      {
        allowedFrom: ['row_blockedUsers'],
        name: 'action_unblock',
        action: () => handleAction('unBlock'),
      },
      {
        allowedFrom: ['row_users'],
        name: 'action_delete',
        action: () => handleAction('delete'),
      },
    ];

    let menuList = UsersActionsList.filter((item) => item.allowedFrom.indexOf(type) > -1);
    setDisplayedMenu(menuList);
  }, [type, ids]);

  return (
    <div className='dropdown-actions'>
      {displayedMenu.length > 0 && (
        <DropdownButton
          disabled={ids.length > 0 ? false : true}
          as={ButtonGroup}
          drop='bottom'
          variant='secondary'
          title={
            <>
              {isActionButton ? (
                <img src={dotsIcon} alt='Loading...' />
              ) : (
                <FormButton text='button_action' variant='green-1' icon={dropdownIcon} />
              )}
            </>
          }
        >
          {displayedMenu.map((button, index) => (
            <Dropdown.Item
              onClick={button.action}
              key={index}
              className='items theme-size-1 theme-text-grey-1 px-3 py-2 cursor-pointer'
            >
              {t(button.name)}
            </Dropdown.Item>
          ))}
        </DropdownButton>
      )}
      <ConfirmationModal
        show={confirmationModal}
        title={t('alert_deletion_title')}
        message={t(
          actionType === 'delete' ? 'alert_delete_user' : 'alert_user_unblock_confirmation_message',
        )}
        actionList={[
          {
            color: 'black-1',
            text: t('button_cancel'),
            onClick: () => setConfirmationModal(false),
          },
          {
            color: 'red-1',
            text: t('button_confirm'),
            loading: loader,
            onClick: () => applyUserAction(),
          },
        ]}
      />
    </div>
  );
}
UsersActions.propTypes = {
  ids: PropTypes.array.isRequired,
  isActionButton: PropTypes.bool.isRequired,
  type: PropTypes.string.isRequired,
  actionsCallBack: PropTypes.func.isRequired,
  row: PropTypes.object,
};
export default UsersActions;
